//
// Module for the Choose Correspondence page
//
rs.module("framework/content/correspondence/choosecorrespondence",

    [ /* Dependencies */ ],

    function () {

        //
        // Initialize the module
        //
        function initialize(jsSelectors) {

            // Unpack js selectors
            var criteria = $.js(jsSelectors.criteria);

            var templateTypeRadioContainer = criteria.js(jsSelectors.templateTypeRadioContainer, { required: false });
            var individualRadioBtn = criteria.js(jsSelectors.individualRadioBtn, { required: false });
            var packetRadioBtn = criteria.js(jsSelectors.packetRadioBtn, { required: false });
            var individualGridContainer = criteria.js(jsSelectors.individualGridContainer);
            var packetGridContainer = criteria.js(jsSelectors.packetGridContainer, { required: false });

            // The radio selector to determine which grid to display is only available for participants.
            if (templateTypeRadioContainer) {

                templateTypeRadioContainer.find('input').click(function () {

                    var selectedRadioBtn = this.value;

                    if (selectedRadioBtn == individualRadioBtn.val()) {
                        packetGridContainer.hide();
                        individualGridContainer.show();
					}
                    else if (selectedRadioBtn == packetRadioBtn.val()) {
                        individualGridContainer.hide();
                        packetGridContainer.show();
					}

                });

			}
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);